import Controller from "./Controller";
import List from "./EditList";

function RecordPanel() {
  return (
    <div className="w-full flex-1 overflow-hidden">
      <div className="h-full flex flex-col rounded-2 overflow-hidden">
        <List />
        <Controller />
      </div>
    </div>
  );
}

export default RecordPanel;
